import React from 'react'
import { useIntl } from 'react-intl'
import HeadData from 'components/Common/HeadData'

interface Props {
  cruiseLine: App.CruiseLine
}

function CruiseLineHeadData({ cruiseLine }: Props) {
  const intl = useIntl()
  const currentYear = new Date().getFullYear()
  const title = intl.formatMessage(
    {
      id: 'GAoPhzDhXTFtHsDYsEoS',
      defaultMessage: '{cruiseLineName} | Best Deals {currentYear}/{nextYear}/{yearAfterNext}',
      description: 'SEO page title for cruise line landing page with year range',
    },
    { cruiseLineName: cruiseLine.name, currentYear, nextYear: currentYear + 1, yearAfterNext: currentYear + 2 },
  )
  const description = intl.formatMessage(
    {
      id: '-fAK8E0HI0AK5PXmf5rC',
      defaultMessage: 'Looking for voyages with {cruiseLineName}? Book your dream cruise at a great price with our exclusive deals. Departure dates in {currentYear}, {nextYear} and {yearAfterNext}.',
      description: 'SEO meta description for cruise line landing page on the promotional landing page',
    },
    { cruiseLineName: cruiseLine.name, currentYear, nextYear: currentYear + 1, yearAfterNext: currentYear + 2 },
  )

  return (
    <HeadData
      title={title}
      description={description}
    />
  )
}

export default CruiseLineHeadData
